module.exports = __webpack_public_path__ + "static/media/ramen-light-pressed.50afba19.gif";